import React from "react";

const DoubleCheckIcon = ({ color = "#94a3b8" }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ marginLeft: "4px", flexShrink: 0 }}
    >
      <path d="M2 12l5.25 5 2.625-3" />
      <path d="M8 12l5.25 5L22 7" />
    </svg>
  );
};

export default DoubleCheckIcon;
